import { HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class NoCacheInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('/i18n/')) {
      const cloned = req.clone({
        params: (req.params ? req.params : new HttpParams()).set('t', Date.now().toString())
      });
      return next.handle(cloned);
    }
    return next.handle(req);
  }
}
